import { resolveId } from '@medplum/core'
import type { AvatarResource } from '@seen/core/models/profile'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import {
  Avatar,
  type AvatarProps,
} from '#src/components/core/Avatar/Avatar.tsx'

export interface AvatarCirclesProps {
  avatars: AvatarResource[]
  numInLastCircle?: number // Note: numInLastCircle is not designed to go above 99.
  size?: AvatarProps['size']
}

export function AvatarCircles({
  avatars,
  numInLastCircle,
  size = 'icon',
}: AvatarCirclesProps): JSX.Element {
  return (
    <div className={cn('-space-x-2.5 flex rtl:space-x-reverse')}>
      {avatars.map((avatar) => (
        <div
          key={resolveId(avatar)}
          className="relative rounded-full border-2 border-white bg-white"
        >
          <Avatar profile={avatar} size={size} />
        </div>
      ))}
      {(numInLastCircle ?? 0) > 0 && (
        <div className="relative rounded-full border-2 border-white bg-white">
          <div className="flex size-5 items-center justify-center rounded-full bg-muted text-center text-3xs font-medium text-muted-foreground">
            +{numInLastCircle}
          </div>
        </div>
      )}
    </div>
  )
}
